"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleDecoder = void 0;
const DecodingUtils_1 = require("./DecodingUtils");
class DoubleDecoder {
    static decodeDoubleStream(data, offset, streamMetadata) {
        return DecodingUtils_1.DecodingUtils.decodeDoublesLE(data, offset, streamMetadata.numValues());
    }
}
exports.DoubleDecoder = DoubleDecoder;
//# sourceMappingURL=DoubleDecoder.js.map